import React from "react";
import useIsMobile from "../../../hooks/useIsMobile";
import DesktopCodeContainer from "./DesktopCodeContainer";
import useDeviceType from "../../../hooks/useDeviceType";
import googleIcon from "../images/non-offer-google.svg";
import appleIcon from "../images/non-offer-apple.svg";
import qrCodeUrl from "../../../../assets/images/enterprise/inkind/icons/inkind-app-qr-code.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBolt, faHeart, faMap } from "@fortawesome/free-solid-svg-icons";
import { StarsReviews } from "./StarsReviews";
import "../stylesheets/non-offer-modal.scss";

const featureHighlights = (locationCount: number) => [
  {
    icon: faBolt,
    text: "Easier than paying with a card",
  },
  {
    icon: faHeart,
    text: "Loved by 3 million foodies",
  },
  {
    icon: faMap,
    text: `${locationCount.toLocaleString()}+ restaurants, bars & cafes`,
  },
];

interface NonOfferModalProps {
  appStoreUrl: string;
  playStoreUrl: string;
  locationCount: number;
  stars?: number;
  reviewsCount?: string;
}

export const NonOfferModal: React.FC<NonOfferModalProps> = ({
  appStoreUrl,
  playStoreUrl,
  locationCount,
  stars,
  reviewsCount,
}) => {
  const { isApple, isAndroid } = useDeviceType();
  const highlights = featureHighlights(locationCount);
  const isMobile = useIsMobile(900);
  const isDesktop = !isApple && !isAndroid;

  return (
    <div className="grid-container">
      <div className="welcome-container">
        <div className="welcome-bonus-container">
          <div className="welcome-bonus-top">
            <p className="superheader">Pay with the inKind app</p>
            <div className="offer-claim-header">
              Get
              {isMobile ? " " : <br />}
              20% back
            </div>
          </div>
          <div className="feature-highlights">
            {highlights.map((feature) => (
              <div className="feature-highlight-item" key={feature.text}>
                <span className="feature-highlight-icon">
                  <FontAwesomeIcon
                    icon={feature.icon}
                    fontSize={24}
                    color="#EEB804"
                  />
                </span>
                <span>{feature.text}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="download-link-container">
          <section className="download-link-body">
            <div className="unlocked-offer-claim-container code-main">
              {isDesktop ? (
                <div className="download-links-desktop">
                  <DesktopCodeContainer
                    qrCodeUrl={qrCodeUrl}
                    appStoreUrl={appStoreUrl}
                    playStoreUrl={playStoreUrl}
                    appleDesktop={appleIcon}
                    googleDesktop={googleIcon}
                    isNonOfferModal={true}
                    stars={stars ?? 0}
                    reviewsCount={reviewsCount}
                  />
                </div>
              ) : (
                <div className="download-links-mobile">
                  {isApple ? (
                    <a
                      className="download-button"
                      href={appStoreUrl}
                      target="_blank"
                    >
                      <img src={appleIcon} alt="app store" />
                    </a>
                  ) : (
                    <a
                      className="download-button"
                      href={playStoreUrl}
                      target="_blank"
                    >
                      <img src={googleIcon} alt="google play" />
                    </a>
                  )}
                  <StarsReviews
                    stars={stars ?? 0}
                    reviewsCount={reviewsCount}
                    isMobile={true}
                  />
                </div>
              )}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};
